import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Usage from "./usage";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<Usage />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
